function refine(value, ...args) {
  return typeof value === 'function' ? value(...args) : value;
}

export default refine;
